var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_163_183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_163_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9128 3.68513C28.8131 4.17242 27.6317 4.50167 26.3898 4.65049C27.6712 3.88372 28.6299 2.67691 29.087 1.25525C27.883 1.97037 26.5654 2.47373 25.1913 2.74346C24.2673 1.75685 23.0433 1.1029 21.7095 0.883158C20.3758 0.663413 19.0067 0.890161 17.8151 1.5282C16.6233 2.16624 15.6756 3.17987 15.119 4.41172C14.5624 5.64357 14.4281 7.02472 14.7368 8.34074C12.2973 8.21825 9.9109 7.58418 7.73228 6.47969C5.55368 5.37519 3.63167 3.82494 2.09097 1.92955C1.56418 2.83829 1.26126 3.89189 1.26126 5.01398C1.26067 6.02412 1.50943 7.01879 1.98546 7.90973C2.46148 8.80067 3.15006 9.56033 3.9901 10.1213C3.01588 10.0904 2.06315 9.82709 1.21122 9.35353V9.43254C1.21112 10.8493 1.70119 12.2224 2.59827 13.3191C3.49535 14.4156 4.74418 15.168 6.13287 15.4486C5.22912 15.6933 4.2816 15.7292 3.36189 15.554C3.7537 16.773 4.5169 17.839 5.54465 18.6028C6.57241 19.3665 7.81326 19.7897 9.09352 19.8131C6.92022 21.5192 4.23623 22.4447 1.4733 22.4406C0.983879 22.4407 0.494865 22.4121 0.00878906 22.355C2.81332 24.1582 6.07801 25.1152 9.41222 25.1115C20.6989 25.1115 26.8692 15.7634 26.8692 7.6559C26.8692 7.3925 26.8626 7.12646 26.8507 6.86306C28.0509 5.99512 29.0869 4.92034 29.9101 3.68907L29.9128 3.68513Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24.31,
    fill: "white",
    transform: "translate(0 0.801514)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_163_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24.31,
    fill: "white",
    transform: "translate(0 0.801514)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_163_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9823,
    height: 24.31,
    fill: "white",
    transform: "translate(0.00878906 0.801514)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/Social-1.5316a96d70752edb2b9c018a85c51bf9.svg";
export { ForwardRef as ReactComponent };